export enum ToggleButtonsColor {
  LIGHT = 'light',
  DARK = 'dark',
  TRANSPARENT = 'transparent',
}

export enum ToggleButtonsVariant {
  DEFAULT = 'default',
  PILL = 'pill',
}

export enum ToggleButtonsSpacing {
  XXXSMALL = 'xxxsmall',
  XXSMALL = 'xxsmall',
  XSMALL = 'xsmall',
  SMALL = 'small',
  MID = 'mid',
}

export type ToggleButtonsIconName = 'ui-close' | 'ui-tick';

interface ValueToggleOption {
  value: string;
  option: string;
}

interface IconToggleOption {
  icon: ToggleButtonsIconName;
  option: string;
}

export type ToggleOption = ValueToggleOption | IconToggleOption;

export interface ToggleButtonOptionContext {
  $implicit: ToggleOption;
  selected: boolean;
}
